import React from 'react'
import { Card, Row, Col } from "react-bootstrap"
import CLabel from '../../../../Common/CLabel'
import { useTranslation } from "react-i18next";
import SidePanelElementSelection from './SidePanelElementSelection';
import { useState } from 'react';
import { CommandBarButton } from '@fluentui/react';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import MainAppContext from '../../../../../MainAppContext';
import { canEditBoardOrGap } from '../../../../../common/Helpers';
import BoardAppContext from '../../../../../BoardAppContext';
import './style-card.css'

function BusinessElementCard(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);
    //Parametros de entrada.
    const {
        inputParam_EditMode = false,
        inputParam_ShowSelected = false,
        inputParam_ElementItem = null,
        inputParam_SetterSelectedElement = null,
        inputParam_TextIsDataLang = false,
        inputParam_SelectedCardId = null,
        inputParam_BoardId = null,
        inputParam_SetterBoardElements = null,
        inputParam_SetterStatusFly = null,
    } = props;
    
    const [isElementSelectionPanelOpen, setIsElementSelectionPanelOpen] = useState(false);
    
    const onOpenElemenSelectionPanel = (e, id) => {
        setIsElementSelectionPanelOpen(true)
    };

    const onSelectCardClick = () => {
        inputParam_SetterSelectedElement && inputParam_SetterSelectedElement(inputParam_ElementItem);
    }

    return (
        <>
            <Card
                className={`cursor-pointer ${ inputParam_ShowSelected ? (inputParam_SelectedCardId ? (inputParam_SelectedCardId === inputParam_ElementItem.id ? "selected-card" : "") : "") : "" }`}
                style={ { fontSize: "13px", borderLeft: `20px solid ${ inputParam_ElementItem.htmlColor !== null && inputParam_ElementItem.htmlColor !== undefined ? inputParam_ElementItem.htmlColor : "" }` }}
                onClick={ inputParam_ElementItem.id !== 0 ? onSelectCardClick : null }>
                <Card.Body className="card-board p-2">
                    <Row>
                        <Col className="card-board-body">
                            <Row>                                
                                <Col xl={12}>
                                    <CLabel className="cursor-pointer" aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-name') } labelValue={ inputParam_TextIsDataLang ? t(inputParam_ElementItem.elementName) : inputParam_ElementItem.elementName } />
                                </Col>
                            </Row>
                        </Col>
                        {
                            inputParam_EditMode && inputParam_SelectedCardId === inputParam_ElementItem.id && (contextSite.securityProps.isAdmin || canEditBoardOrGap(contextBoard.userPropsKpi.value)) &&
                            <Col className='col-auto'>
                                <CommandBarButton
                                    iconProps={ { iconName: 'CircleAddition' } }
                                    text={ t('data-lang-btn-add') }
                                    disabled={false}
                                    styles={{root: {backgroundColor: "transparent"}}}
                                    onClick={ onOpenElemenSelectionPanel }
                                />
                            </Col>
                        }
                    </Row>
                </Card.Body>
                {
                    inputParam_EditMode &&
                    <SidePanelElementSelection
                        inputParam_SelectedElementType={ inputParam_ElementItem }
                        inputParam_IsPanelOpen={isElementSelectionPanelOpen}
                        inputParam_SetterIsPanelOpen={setIsElementSelectionPanelOpen}
                        inputParam_BoardId={inputParam_BoardId}
                        inputParam_SetterBoardElements={inputParam_SetterBoardElements}
                        inputParam_SetterStatusFly={inputParam_SetterStatusFly}
                    />
                }
            </Card>
        </>
    );
}

///Proptypes
BusinessElementCard.propTypes = {
    inputParam_BoardId: PropTypes.number.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_ShowSelected: PropTypes.bool.isRequired,
    inputParam_ElementItem: PropTypes.object.isRequired,
    inputParam_SelectedCardId: PropTypes.number.isRequired,
    inputParam_TextIsDataLang: PropTypes.bool,
    inputParam_SetterSelectedElement: PropTypes.func.isRequired,
    inputParam_SetterBoardElements: PropTypes.func,
    inputParam_SetterStatusFly: PropTypes.func,
};

export default BusinessElementCard;